<template>
  <v-dialog
    v-model="openaiDialogShow"
    max-width="75%"
  >
    <template v-slot:activator="{}">
      <v-btn
        class="mx-2"
        :color="buttonClass()"
        :loading="loading"
        dark
        fab
        small
        @click="openDialog"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="font-weight-bold"
              v-bind="attrs"
              v-on="on"
            >AI</span>
          </template>
          generate AI description
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">OpenAI: {{ geotag.name ? geotag.name : '' }}</span>
      </v-card-title>

      <v-card-text>
        <div class="py-3">
          <div class="d-flex">
            <h3 class="mb-4">Input</h3>
            <v-spacer></v-spacer>
            <v-btn @click="getDescription" color="primary">
              <span class="pr-2">Go</span>
              <v-icon>mdi-auto-fix</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="py-3">
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Instructions
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="prompt"
                  outlined
                  rows="3"
                  hide-details
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <h3 class="mb-4">Output</h3>
        <h4 class="black--text">
          Description: - Tell me about this in 100 words.
        </h4>
        <v-radio-group v-model="radioDescriptions" row>
          <v-container>
            <v-row
              v-for="(description, index) in descriptions"
              :key="index"
              align="center"
              justify="center"
              :class="description.type === 'new' ? 'green accent-1' : ''"
            >
              <v-col class="flex-grow-1 flex-shrink-0">
                <v-textarea
                  v-model="descriptions[index].text"
                  outlined
                  dense
                  :counter="true"
                ></v-textarea>
              </v-col>
              <v-col class="text-center flex-grow-0 flex-shrink-1">
                <v-radio
                  :value="index"
                ></v-radio>
              </v-col>
            </v-row>
          </v-container>
        </v-radio-group>

        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Raw response
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-textarea
                v-model="row"
                outlined
                hide-details
                dense
              ></v-textarea>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="openaiDialogShow = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="saveData"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OpenAiGeotag',
  props: {
    geotagData: {
      type: Object,
      default() {
        return {};
      },
    },
    geotagId: {
      type: Number,
      default: null,
    },
    triggerRun: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    geotag: {},
    openaiDialogShow: false,
    prompt: 'You are an expert travel guide.  Write 3 versions of a one sentence description of {Geotag}\n1.\n2.\n3.',
    radioDescriptions: 0,
    descriptions: [],
    row: '',
    loading: false,
  }),

  created() {
    if (Object.keys(this.geotagData).length) {
      this.initData(this.geotagData);
    }
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    openDialog() {
      if (Object.keys(this.geotag).length) {
        this.openaiDialogShow = true;
      } else if (Object.keys(this.geotagData).length) {
        this.initData(this.geotagData);
      } else {
        this.$requestHelpers
          .get(`api/admin/geotag/${this.geotagId}`)
          .then((response) => {
            this.initData(response.data);
          });
      }
      this.openaiDialogShow = true;
    },

    initData(data) {
      this.geotag = data;
      this.headlines = [];
      this.descriptions = [];
      if (this.geotag.description) {
        this.descriptions.push({ text: this.geotag.description, type: 'old' });
      }
      this.replacePromptText();
    },

    buttonClass() {
      let buttonClass = 'primary';

      if (this.descriptions.length) {
        buttonClass = 'green';
      }

      if (this.row) {
        buttonClass = 'orange';
      }

      return buttonClass;
    },

    replacePromptText() {
      const geotagFullName = `${this.geotag.name}, ${this.geotag.country} (${this.geotag.lat}, ${this.geotag.lon})`;
      this.prompt = this.prompt.replaceAll('{Geotag}', geotagFullName);
    },

    getDescription(withOverlay = true) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.$requestHelpers
        .post(
          'api/admin/openai',
          {
            prompt: this.prompt,
          },
          {
            withOverlay,
          },
        )
        .then((response) => {
          const text = `${response.data}\n\n`;
          this.row = text;

          // get descriptions + headlines
          const regex = new RegExp('[0-9][.)] *(.*?)\\n', 'sig');
          let res;
          // eslint-disable-next-line no-cond-assign
          while ((res = regex.exec(text)) != null) {
            this.descriptions.push({ text: res[1].trim(), type: 'new' });
          }
          this.headlines = this.removeDuplicates(this.headlines);
          this.descriptions = this.removeDuplicates(this.descriptions);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveData() {
      const data = {
        description: this.descriptions[this.radioDescriptions]?.text,
      };
      this.$requestHelpers
        .patch(`api/admin/geotag/${this.geotag.id}`, data)
        .then((response) => {
          if (response.data.success) {
            this.initData(response.data.result);
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
            this.row = '';
            this.openaiDialogShow = false;
            this.$emit('updateGeotagData', response.data.result);
          }
        });
    },

    removeDuplicates(arr) {
      const unique = [];
      const newArr = [];
      for (let i = 0; i < arr.length; i += 1) {
        if (unique.indexOf(arr[i].text) === -1) {
          unique.push(arr[i].text);
          newArr.push(arr[i]);
        }
      }
      return newArr;
    },
  },
  watch: {
    triggerRun() {
      this.getDescription(false);
    },
  },
};
</script>
